export const text = {
    title: {
        loading: 'Verifying information…',
        submitting: 'Sending registration…',
        input: 'Complete Your Registration',
        done: 'Registration Complete!',
    },
    helpEmail: 'aws-marketplace-fulfillment@extrahop.com',
    loading: [
        'Please provide your information to register for a Reveal(x) 360: Saas-Based Network Detection and Response subscription.',
        'If you have questions, you can contact us at',
    ],
    thanks: [
        'Thank you for registering for Reveal(x) 360: SaaS-Based Network Detection and Response. You will receive an email from ExtraHop with instructions about how to access your Reveal(x) 360 environment.',
        'If you have any questions, you can contact us at',
    ],
    editionText: 'Reveal(x) 360',
    testError: {
        code: 555,
        message: 'This is a test error',
        data: 'something technical',
    },
    errorHelp: 'For assistance, please contact us at',
    tokenMissingError: {
        code: -3,
        message: 'Try to register again, or contact us.',
    },
    first: 'First Name',
    last: 'Last Name',
    email: 'Email Address',
    company: 'Company Name',
    host: 'Preferred Hostname',
    hostHint:
        'Hostnames must begin with a letter and can only contain lowercase letters, numbers, and dashes.',
    hostInUseError:
        'This hostname is already registered. Try another hostname.',
    hostExample: 'hostname',
    domain: 'cloud.extrahop.com',
    regionHeader: 'Hosting Location',
    regions: {
        US: 'United States',
        EU: 'EMEA',
        APAC: 'APAC',
    },
    submit: 'Complete Registration',
    oops: 'Oops! Something went wrong.',
    unexpected: 'Unexpected case: ',
} as const;
